let utils = require('../../../actions/utils');
let content = require('../../../actions/layout/content');
let userGroup = require('../../groups/user');
let layoutGroup = require('../../groups/layout');
let analytics = require('../../../actions/analytics');
let seo = require('../../../actions/seo');
let page = require('../../../actions/page');
let statistic = require('../../../actions/account/statistic');

module.exports = [
    ...userGroup.checkAuthCookie([
        ...userGroup.getUser
    ]),
    ...userGroup.access('manager', [
        page.cleanup(),
        analytics.parseUtmFromQuery,
        utils.set(['user', 'role'], 'manager'),
        utils.set('layout', 'footless'),
        ...layoutGroup.setMainLayoutBlocks,
        seo.setDashboardMeta('Статистика заказа', 'Статистика заказа'),
        content.setComponentsByLink,
        statistic.setComputedFields,
        utils.setFromArgsToState('orderId', ['account', 'statistic', 'orderId']),
        utils.setFromArgsToState('isByBranch', ['account', 'statistic', 'isByBranch']),
        utils.setFromArgsToState('isTransposed', ['account', 'statistic', 'isTransposed'])
    ])
];



// WEBPACK FOOTER //
// ./signals/pages/account/statistic.js